import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'DeleteObject',
    templateUrl: './DeleteObject.html'
})

export class DeleteObject extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    //@Input() AllDeviceData: Array<StaffDevice>;
    ModalRef: NgbModalRef;
    Model: any;
    RequestData: any;
    DisableModalOpenEvent: boolean = false;

    @Output() ObjectDeleted: EventEmitter<any> = new EventEmitter<any>();
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }
    ngOnInit(): void {

    }

    Open(Name: string, Data: any): void {
        if (this.DisableModalOpenEvent) return;
        this.Model = Name;
        this.RequestData = Data;
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    Delete(): void {
        this.ObjectDeleted.emit(this.RequestData);
        this.ModalRef.close();
    }

}
